import { RouteMenus, RoutePaths } from 'routes/route.roles';
import { ApplicationStep } from 'services/applicant/applicant.service.class';
import { ApplicationSubmenus } from './application-menus';
import { NavMenuItem } from './navmenu.service';

export const AllMenuItems: NavMenuItem[] = [
    {
        MenuID: RouteMenus.Home,
        MenuIcon: 'home',
        MenuText: 'Home',
        IsHome: true,
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
        Route: RoutePaths.Home,
    },
    {
        MenuID: RouteMenus.MyApplication,
        MenuIcon: 'warning',
        IconClasses: ['warnforeground500'],
        LaunchHeader: 'Missing Important Information',
        DefaultEnabled: false,
        DisplayAsLaunch: true,
        DisplayAsMenu: false,
        Description: `<div class="eRefEmails warnforeground500 mat-subheading-2 margin-bottom-none">References: Email Address is Required.</div><div class="empHist warnforeground500 mat-subheading-2 margin-bottom-none">Employment History: Email Address is Required.</div>`,
        LaunchButtonText: 'Work On My Application',
        Route: RoutePaths.ApplicationStatus,
    },
    {
        MenuID: RouteMenus.MyApplication,
        MenuIcon: 'person',
        MenuText: 'My Job Application',
        DefaultEnabled: true,
        DisplayAsLaunch: true,
        DisplayAsMenu: true,
        Description: `In order to apply for a job, we need to collect some information about you. Once you have completed
    <strong>and</strong> submitted the application, your information will be available to our hiring managers.`,
        LaunchButtonText: 'Work On My Application',
        // #region Application Substeps
        Submenus: ApplicationSubmenus, // Defined in other file for conciseness
        // #endregion
        Route: RoutePaths.ApplicationStatus,
        IsExpanded: false,
    },
    {
        MenuID: RouteMenus.AppTranscripts,
        MenuIcon: 'school',
        MenuText: 'My Transcripts & Credentialing',
        DefaultEnabled: true,
        DisplayAsLaunch: true,
        DisplayAsMenu: false,
        Description: `If you have recently been selected for an interview, you may need to upload a current/recent
        copy of your unofficial transcripts or other credentialing documentation showing your credit hours and any degrees earned.`,
        LaunchButtonText: 'Manage My Documents',
        Route: RoutePaths.Transcripts,
    },
    {
        MenuID: RouteMenus.BrowseJobs,
        MenuIcon: 'search',
        MenuText: 'Browse Jobs',
        DefaultEnabled: true,
        LaunchHeader: 'Browse Advertised Positions',
        DisplayAsLaunch: true,
        DisplayAsMenu: true,
        Description: `Look for advertised positions and notify the hiring manager of your interest.`,
        LaunchButtonText: 'Start Job Hunting',
        Route: RoutePaths.JobBrowser,
    },
    {
        MenuID: RouteMenus.MyInterviews,
        MenuIcon: 'event_available',
        MenuText: 'My Interviews',
        DefaultEnabled: true,
        LaunchHeader: 'View Scheduled Interviews',
        DisplayAsLaunch: true,
        DisplayAsMenu: true,
        Description: `View scheduled interviews. Accept or Decline the interview.`,
        LaunchButtonText: 'View My Interviews',
        Route: RoutePaths.Interviews,
    },
    {
        MenuID: RouteMenus.JobFairs,
        MenuIcon: 'work',
        MenuText: 'Job Fairs',
        LaunchHeader: 'Employee Job Fairs',
        DefaultEnabled: false,
        DisplayAsLaunch: true,
        DisplayAsMenu: true,
        Description: `Are you looking to become hired by Polk County Schools?`,
        LaunchButtonText: 'Register Now!',
        ExternalURL: 'https://jobfair.polk-fl.net',
    },
    {
        MenuID: RouteMenus.PCPSConnect,
        MenuIcon: 'link',
        MenuText: 'PCPS Connect',
        LaunchHeader: 'Current Employee Connect',
        DefaultEnabled: false,
        DisplayAsLaunch: true,
        DisplayAsMenu: true,
        Description: `If you are a current employee, you must connect your application with your PCPS account.`,
        LaunchButtonText: 'Connect Accounts Now',
        Route: RoutePaths.PCPSConnect,
    },
    {
        MenuID: RouteMenus.HelpDocs,
        MenuIcon: 'custompdf',
        SVGIcon: true,
        MenuText: 'Helpful Documents',
        DefaultEnabled: true,
        DisplayAsLaunch: true,
        DisplayAsMenu: true,
        Description: `<ul><li><a href="assets/Onboarding-What_To_Expect.pdf" target="_blank">Hiring Process</a></li></ul>`,
        LaunchButtonText: '',
        Submenus: [
            {
                MenuID: RouteMenus.HelpDocsHiring,
                MenuText: 'Hiring Process',
                DisplayAsMenu: true,
                ExternalURL: 'assets/Onboarding-What_To_Expect.pdf',
                DefaultEnabled: true,
            },
        ],
    },
    {
        MenuID: RouteMenus.Logout,
        MenuIcon: 'logout',
        MenuText: 'Log Out',
        IsLogout: true,
        DefaultEnabled: true,
        DisplayAsLaunch: false,
        DisplayAsMenu: true,
    },
];
